export const ITEM_INDENT = 3;
export const ELEMENTS_GAP = 2;
export const ITEM_HEIGHT = 6.625;
export const THEME_SPACING_DIVIDER = 8;
export const ITEM_HEIGHT_DIVIDER = 6;
